module.exports = __webpack_public_path__ + "img/T6-D-rc_4.8b0ddd7f.png";